import {
  GET_REPORTS_DATA,
  GET_REPORTS_LIST,
  EMPTY_REPORT_DATA,
  PAGE_LOADING,
} from "../../constants/types";

import moment from 'moment';
import axios from "axios";


export const emptyReports = () => {
  return (dispatch, getState) => {
    dispatch({
      type: EMPTY_REPORT_DATA,
    })
  }
}

export const getReportsList = () => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      axios
        .get("api/reports/list/")
        .then(res => {
          console.log(res, 'Report List Res')
          if (res.status === 200) {
            dispatch({
              type: GET_REPORTS_LIST,
              payload: res.data
            });
            resolve(res);
          } else {
            reject(res);
          }
        }).catch(err => {
          reject(err)
        })

    })

  };
};

export const getReports = (date, report_name, locations) => {
  return (dispatch, getState) => {
    return new Promise((resolve, reject) => {
      const getDate = (date) => {
        switch (date.toLowerCase()) {
          case 'today':
            return {
              start_date: moment().format('YYYY-MM-DD'),
              end_date: moment().format('YYYY-MM-DD'),
            }
          case 'yesterday':
            return {
              start_date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
              end_date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
            }
          case 'last_7_days':
            return {

              start_date: moment().subtract(7, 'days').format('YYYY-MM-DD'),
              end_date: moment().subtract(1, 'days').format('YYYY-MM-DD')
            }
          case 'last_30_days':
            return {
              start_date: moment().subtract(30, 'days').format('YYYY-MM-DD'),
              end_date: moment().subtract(1, 'days').format('YYYY-MM-DD'),
              type: 'oscar_dashboard'
            }
          case 'this_month':
            return {
              start_date: moment().startOf('month').format('YYYY-MM-DD'),
              end_date: moment().format('YYYY-MM-DD'),
            }
          case 'last_month':
            return {
              start_date: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
              end_date: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD'),
            }
        }
      }
      axios
        .get("api/reports/report/", {
          params: {
            // ...getDate(date),
            ...date,
            report_name,
            type: 'oscar_dashboard',
            locations: [locations]
          }
        }).then(res => {
          console.log('report res: ', res)
          if (res.status === 200) {
            dispatch({
              type: GET_REPORTS_DATA,
              payload: res.data
            });
            resolve(res);
          } else {
            reject(res);
          }

        }).catch(err => {
         reject(err)
        })
   })
  }
};



// WEBPACK FOOTER //
// ./src/modules/reports/ReportsActions.js